import { useTranslation } from 'next-i18next';
import { AboutComponent } from '@/widgets/AboutComponent';
import { getAutomationBenefits } from '../lib/automationBenefits';

const AutomationBenefits = () => {
  const { t } = useTranslation();
  const automationBenefits = getAutomationBenefits(t);

  return (
    <>
      {automationBenefits.map(({ description, heading, img }, index) => (
        <AboutComponent
          key={heading}
          containerProps={{ gap: '20' }}
          description={description}
          heading={heading}
          image={img}
          imageAlt={heading}
          imageProps={{ maxW: '24rem' }}
          isOdd={index % 2 === 1}
        />
      ))}
    </>
  );
};

export default AutomationBenefits;
